// @ts-check
// Backend 7f1e0ba4 (2026-09-28): admin unbind clears the device AND every registration and
// PoP enrolment field, exactly like unregister; admin bind refuses a registered licence (409).
//
// Wording ruled by Michael 2026-09-29 (unbind is offered only to remove a pre-bind). Every
// user-visible string for unbind and the bind conflict lives HERE, so a wording change from
// Michael is a one-line edit in this file. Unregister and regenerate-key copy (they also revoke
// the activation label) lives in labelReissueCopy.js.
export const DEVICE_BINDING_COPY = {
  unbindTitle: (serialNumber) => `Unbind device from ${serialNumber}?`,
  unbindBody:
    'This removes the pre-bound device from this licence. The licence stays unregistered and can be bound or activated again.',
  unbindConfirmLabel: 'Unbind',
  unboundToast: (serialNumber) => `Unbound ${serialNumber}. The licence stays unregistered.`,
  bindConflict: (serialNumber) => `Licence ${serialNumber} is registered to a device. Unregister it first.`,
};
